'use strict';
angular.module("selectStatusServiceModule", [])
    .factory("selectStatusService", ["$modal", "$q", function($modal, $q) {
        return {
            selectType: function() {
                var data = {
                    publishType: [{ name: '全部', value: '0' },
                        { name: '增量发布', value: '1' },
                        { name: '完全发布', value: '2' },
                        { name: '更新发布', value: '5' },
                        { name: '单篇发布', value: '3' },
                        { name: '撤销发布', value: '7' },
                        { name: '直接发布', value: '10' },
                        { name: '仅发布首页', value: '8' },
                        { name: '删除内容同步更新栏目', value: '12' }
                    ],
                    publishState: [{ name: '全部', value: '0' },
                        { name: '正在执行', value: '5' },
                        { name: '等待执行', value: '1' },
                        { name: '执行成功', value: '7' },
                        { name: '执行失败', value: '9' }
                    ],
                    searchWordType: [{ name: '全部', value: 'TASKTITLE,CRUSER' },
                        { name: '任务名称', value: 'TASKTITLE' },
                        { name: '发布人', value: 'CRUSER' }
                    ],
                    timeRange: [{ name: '--请选择--', value: '0' },
                        { name: '本 周', value: '1' },
                        { name: '本 月', value: '2' },
                        { name: '本 季', value: '3' },
                        { name: '本 年', value: '4' },
                        { name: '指 定', value: '5' }
                    ]
                }
                return data;
            }

        };
    }]);